/**
 * @file Currency Formatter
 * @author michael@on-running.com
 *
 * @module utility/currency-formatter
 *
 *
 */

export function format(amount, currency, forceNaturalNumber = false) {
  const noDecimalsCurrencies = ['JPY', 'KRW']
  const currencyDefaults = {
    code: '',
    decimalMark: '.',
    symbol: '',
    symbolFirst: true,
    thousandsSeparator: "'",
  }
  const currencySettings = Object.assign({}, currencyDefaults, currency)
  //Temporary hack: "noDecimals" information should live within currency
  const decimals =
    noDecimalsCurrencies.includes(currencySettings.code) || forceNaturalNumber ? 0 : 2
  const amountStr = amount.toFixed(decimals)

  // Alternative (probably more robust) approach but not in line with other currency displayment
  // const amountLocalized = Number(amount).toLocaleString(On.Store.state.page.locale)

  const amountWithDecimalMark = amountStr.split('.').join(currencySettings.decimalMark)

  const amountWithThousandsSeparator = amountWithDecimalMark.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    currencySettings.thousandsSeparator
  )
  return currencySettings.symbolFirst
    ? `${currencySettings.symbol}${amountWithThousandsSeparator}`
    : `${amountWithThousandsSeparator}${currencySettings.symbol}`
}
